export { default } from '@/screens/ResetPasswordScreen';
